const mosquitoStatus = {
  2: { label: 'CONFIRMED', color: '#16a34a' },
  1: { label: 'LIKELY', color: '#eab308' },
  0: { label: 'UNKNOWN', color: '#f97316' },
  [-1]: { label: 'UNLIKELY', color: '#3b82f6' },
  [-2]: { label: 'RULED OUT', color: '#8b5cf6' },
  [-3]: { label: 'INVALIDATED', color: '#dc2626' },
}

const certaintyOrder = {
  'CONFIRMED': 6,
  'LIKELY': 5,
  'UNKNOWN': 4,
  'UNKOWN': 4,
  'UNLIKELY': 3,
  'RULED OUT': 2,
  'INVALIDATED': 1,
}

export {
  mosquitoStatus,
  certaintyOrder,
}
